import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
} from '../styles';
import { ArrowLink, Container, Heading } from './ui';
import EbookList from './EbookList';

const StyledFeaturedEbooks = styled.section`
  ${sectionMargins('45px', '90px')};
`;

const StyledInner = styled.div`
  ${sectionPaddings('40px', '90px')};
  background-color: ${brandColours.primary};
  border-radius: 50px;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 40px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 60px;
  `}
`;

const StyledLink = styled(ArrowLink)`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}
`;

const FeaturedEbooks = ({ heading, items: initialItems }) => {
  const {
    datoCmsEbookListing: { slug },
    allDatoCmsEbook: { nodes },
  } = useStaticQuery(graphql`
    query FeaturedEbooksQuery {
      datoCmsEbookListing {
        slug
      }
      allDatoCmsEbook(sort: { position: ASC }, limit: 4) {
        nodes {
          ...EbookCardFragment
        }
      }
    }
  `);

  const items = initialItems && initialItems.length > 0 ? initialItems : nodes;

  return (
    <StyledFeaturedEbooks>
      <Container wider={true}>
        <StyledInner>
          <Container narrow={true}>
            <StyledHeading>{heading}</StyledHeading>
            <EbookList items={items} />
            <StyledLink to={slug}>View all eBooks</StyledLink>
          </Container>
        </StyledInner>
      </Container>
    </StyledFeaturedEbooks>
  );
};

export default FeaturedEbooks;
